import { combineReducers } from 'redux';
import trackingReducers from './tracking/reducers';
import {
    primaryProductsReducer,
    secondaryProductsReducer,
    newProductRandomizedReducer,
    productRelativesReducer,
    bestSellerProductReducer,
} from './products/reducers';
import wishlistReducer, { wishlistQueueReducer } from './wishlist/reducers';
import loginReducer from './user/reducers';
import cartReducer from './cart/reducers';
import bannersReducer from './banners/reducers';
import overlaysReducer from './overlays/reducers';
import { shopToClubABTestReducer } from './shopToClubBanner/shopToClubBannerABTest';
import categoryReducer from './category/reducer';
import brandsReducer from './brands/reducer';
import searchSuggestionReducer from './search/reducers';
import clubIntegrationReducer from './user/clubIntegrationReducer';
import clubRegistrationReducer from './user/clubRegistration/reducer';
import isFacebookOnlyUserReducer from './user/facebook/reducer';
import redirectReducer from './redirect/reducers';
import infusionReducer from './infusions/reducer';
import dataFetchingReducer from './dataFetching/reducer';
import { configurationsReducer } from './configurations';
import notificationsReducer from './notifications/reducer';
import cmsReducer from './cms/reducers';
import looksReducer from './looks/reducer';
import helpCenterReducer from './helpCenter/reducer';
import homepageReducer from './homepage/reducer';
import { homePageSeoReducer, seoReducer } from './seo/reducer';
import eventsQueueReducer from './eventsQueue/reducers';
import productdetailReducer from './productdetail/reducer';
import boughtProductReducer from './user/lastBoughtProduct/reducer';
import headerBarbannerReducer from './headerBarBanner/reducer';
import valuePropsReducer from './valuePropositions/reducer';
import backInStockReminderReducer from './backInStockReminder/reducer';

const rootReducer = combineReducers({
    products: primaryProductsReducer,
    secondaryProducts: secondaryProductsReducer,
    wishlist: wishlistReducer,
    wishlistQueue: wishlistQueueReducer,
    login: loginReducer,
    tracking: trackingReducers,
    cart: cartReducer,
    banners: bannersReducer,
    overlays: overlaysReducer,
    shopToClubABTest: shopToClubABTestReducer,
    categories: categoryReducer,
    brands: brandsReducer,
    searchSuggestion: searchSuggestionReducer,
    seoData: seoReducer,
    homePageSeoData: homePageSeoReducer,
    clubIntegration: clubIntegrationReducer,
    clubRegistration: clubRegistrationReducer,
    isFacebookOnlyUser: isFacebookOnlyUserReducer,
    redirect: redirectReducer,
    dataFetching: dataFetchingReducer,
    infusions: infusionReducer,
    configurations: configurationsReducer,
    notifications: notificationsReducer,
    cms: cmsReducer,
    looks: looksReducer,
    helpCenter: helpCenterReducer,
    homepage: homepageReducer,
    newRandomizedProducts: newProductRandomizedReducer,
    bestSellerProducts: bestSellerProductReducer,
    productRelatives: productRelativesReducer,
    eventsQueue: eventsQueueReducer,
    productdetails: productdetailReducer,
    userProducts: boughtProductReducer,
    headerBarBanner: headerBarbannerReducer,
    valueProps: valuePropsReducer,
    backInStockReminder: backInStockReminderReducer,
});

export default rootReducer;
